// Throwaway password for accounts created on the fly (email-link sign-up, guest
// reply). These used to share the literal "TempPass123", which let anyone sign
// in to every such account. The user sets a real password via the emailed link.
export function randomPassword() {
  const bytes = new Uint8Array(24);
  crypto.getRandomValues(bytes);
  return Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
}
